import { combineReducers } from 'redux';

// Reducers
import authors from './authors/reducer';
import folders from './folders/reducer';
import groups from './groups/reducer';
import institutions from './institutions/reducer';
import keywords from './keywords/reducer';
import shapes from './shapes/reducer';
import themes from './themes/reducer';
import types from './types/reducer';

export default combineReducers({
	authors,
	folders,
	groups,
	institutions,
	keywords,
	shapes,
	themes,
	types
});


// WEBPACK FOOTER //
// ./src/state/domains/reducer.js